<div class="camera-container">
  <div class="row" (mouseover)="mouseover($event)" (mouseout)="mouseout($event)">
    <div class="camera-canvas col-12">
      <div id="nb-global-spinner" class="spinner">
        <div class="blob blob-0"></div>
        <div class="blob blob-1"></div>
        <div class="blob blob-2"></div>
        <div class="blob blob-3"></div>
        <div class="blob blob-4"></div>
        <div class="blob blob-5"></div>
      </div>
      <div class="text-center">
        <canvas #canvas
          (mousedown)="mousedown($event)"
          (mouseup)="mouseup($event)"
          (mousemove)="mouseMove($event)"
          [width]="scope.videoWidth" 
          [height]="scope.videoHeight" 
          class="canvas">
        </canvas>
        <div class="video-header" *ngIf="scope.isLive; else VOD">
          <div class="text-right">
            <span class="title">LIVE</span>
          </div>
        </div>
        <ng-template #VOD>
          <div class="video-header">
            <div class="text-right">
              <span class="title">VOD</span>
            </div>
          </div>
        </ng-template>
        <button class="setting-btn" mat-raised-button color="accent" (click)="openDialog()" >情報</button>
        <div class="col-12">
          <div class="time text-center">{{ scope.currentTime }}</div>
        </div>
        <div class="contoller-group">
          <div class="contoller" (mouseover)="mouseover($event)" [style.visibility]="scope.hover ? 'visible' : 'hidden'">
            <span>
              <a (click)="paly()">
                <i class="fas fa-play" *ngIf="!scope.isPlay"></i>
                <i class="fas fa-pause" *ngIf="scope.isPlay"></i>
              </a>
            </span>
          </div>
          <button class="live-btn" mat-raised-button color="accent" (click)="moveTo(-15)" >15分前</button>
          <button class="live-btn" mat-raised-button color="accent" (click)="moveTo(0)" >LIVE</button>
          <div class="playback-rate" [style.visibility]="!scope.isLive && scope.hover ? 'visible' : 'hidden'">
            <label for="playback-rate" style="color: white;">再生速度 : </label>
            <select id="playback-rate" [(ngModel)]="scope.rate" (change)="playbackRate()">
              <option value="0.5">0.5</option>
              <option value="0.75">0.75</option>
              <option value="1.0" selected>1.0</option>
              <option value="1.25">1.25</option>
              <option value="1.5">1.5</option>
              <option value="1.75">1.75</option>
              <option value="2.0">2.0</option>
              <option value="3.0">3.0</option>
              <option value="5.0">5.0</option>
            </select>
          </div>
        </div>
        <div class="row" (mouseover)="mouseover($event)" [style.visibility]="scope.hover ? 'visible' : 'hidden'">
          <div class="zoom form-group">
            <div class="zoom-icon" >
              <span class="title">-</span>
            </div>
            <input type="range" 
                  min="1" max="10" step="0.1" 
                  [(ngModel)]="canvasEventScope.imageScale"
                  (change)="changeZoom()"
                  class="custom-range"
                  style="padding-top: 25px;">
            <div class="zoom-icon">
              <span class="title">+</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <video hidden #camera class="camera video-js" crossorigin muted preload="auto"></video>

  <dialog id="demo-modal">
    <h2 class="modal-header">詳細情報</h2>
    <div class="modal-body">
      <div class="info-text-group">
        <div class="info-span"><div class="info-text-title">ID</div></div>
        <div class="info-text">{{ infoScope.id }}</div>
      </div>
      <div class="info-text-group">
        <div class="info-span"><div class="info-text-title">名前</div></div>
        <div class="info-text">{{ infoScope.name }}</div>
      </div>
      <div class="info-text-group">
        <div class="info-span"><div class="info-text-title">説明</div></div>
        <div class="info-text">{{ infoScope.description }}</div>
      </div>
      <div class="info-text-group">
        <div class="info-span"><div class="info-text-title">保存期間</div></div>
        <div class="info-text">{{ infoScope.hour }}時間</div>
      </div>
    </div>
    <footer class="modal-footer">
      <button id="close" class="close-btn" mat-raised-button color="accent">閉じる</button>
    </footer>
  </dialog>

  <video id = "popupThumbnail" class="popup-capture" muted #videoPlayer >
    <source src/>
  </video>

  <div class="row">
    <div class="col-12" style="padding: 10px;">
      <button class="skip-btn" mat-raised-button color="accent" (click)="skipVideo('prev')">前の検出</button>
      <button class="skip-btn" mat-raised-button color="accent" (click)="skipVideo('next')">次の検出</button>
      <div class="time-scale-guide">タイムスケールの変更</div>
      <button class="scale-btn" mat-raised-button color="accent" (click)="changeScale(720)">24H</button>
      <button class="scale-btn" mat-raised-button color="accent" (click)="changeScale(360)">12H</button>
      <button class="scale-btn" mat-raised-button color="accent" (click)="changeScale(180)">6H</button>
      <button class="scale-btn" mat-raised-button color="accent" (click)="changeScale(30)">1H</button>
      <button class="scale-btn" mat-raised-button color="accent" (click)="changeScale(5)">10M</button>
    </div>
    <div class="col-12">
      <div #timeline></div>
    </div>
    <div class="col-12 text-center week-day">
      <mat-form-field class="calendar">
        <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDay" placeholder="日付を選択" readonly (dateInput)="selectedCalendar(selectedDay)" >
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 text-center week-day">
      <div><button class="seek-btn" mat-mini-fab color="accent" (click)="moveDays(6)">{{ week.wDate[6] }}</button><span class="{{ week.class[6] }}">{{ week.wDay[6] }}</span></div>
      <div><button class="seek-btn" mat-mini-fab color="accent" (click)="moveDays(5)">{{ week.wDate[5] }}</button><span class="{{ week.class[5] }}">{{ week.wDay[5] }}</span></div>
      <div><button class="seek-btn" mat-mini-fab color="accent" (click)="moveDays(4)">{{ week.wDate[4] }}</button><span class="{{ week.class[4] }}">{{ week.wDay[4] }}</span></div>
      <div><button class="seek-btn" mat-mini-fab color="accent" (click)="moveDays(3)">{{ week.wDate[3] }}</button><span class="{{ week.class[3] }}">{{ week.wDay[3] }}</span></div>
      <div><button class="seek-btn" mat-mini-fab color="accent" (click)="moveDays(2)">{{ week.wDate[2] }}</button><span class="{{ week.class[2] }}">{{ week.wDay[2] }}</span></div>
      <div><button class="seek-btn" mat-mini-fab color="accent" (click)="moveDays(1)">{{ week.wDate[1] }}</button><span class="{{ week.class[1] }}">{{ week.wDay[1] }}</span></div>
      <div><button class="seek-btn" mat-mini-fab color="accent" (click)="moveDays(0)">{{ week.wDate[0] }}</button><span class="{{ week.class[0] }}">{{ week.wDay[0] }}</span></div>
    </div>
  </div>
</div>